// The homepage approach table's rows: technical win -> business change -> business value, for three
// demo use cases, worded as on the use-case value slides. The technical win is a phrase (no numbers);
// the business-change and business-value cells are the authored copy in `data/use-case-story-copy.ts`
// (shared with the executive deck). The rows are CRM enrichment, Inbound speed-to-lead and
// Signal-based outbound.

import { useCaseStoryCopy } from '../../data/use-case-story-copy';
import { getSizedUseCase } from '../../data/use-case-catalog';

export interface ApproachRow {
  useCaseId: string;
  useCase: string;
  win: string;
  change: string;
  value: string;
}

const COPY: { useCaseId: string; win: string }[] = [
  { useCaseId: 'uc-crm-enrichment', win: 'Higher fill rate on account records' },
  { useCaseId: 'uc-inbound-speed-to-lead', win: 'More inbound leads matched and routed in minutes' },
  { useCaseId: 'uc-signal-based-outbound', win: 'Higher meeting rate on signal-triggered outreach' },
];

export function approachRows(): ApproachRow[] {
  return COPY.flatMap(({ useCaseId, win }) => {
    const uc = getSizedUseCase(useCaseId);
    const copy = useCaseStoryCopy(useCaseId);
    if (!uc || !copy) return [];
    return [{ useCaseId: uc.id, useCase: uc.name, win, change: copy.change, value: copy.value }];
  });
}
